module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門2_2_3.84f6b290.png";